import { StoreCode } from '../../../schema/storeCode';
import { document } from './document.storefront';
import { shopifyStorefrontRequest } from '../shopifyStorefrontRequest';
import { ShopifyStorefrontCustomerQuery } from './types';

export function getCustomer(
  customerAccessToken: string,
  storeCode: StoreCode
): Promise<ShopifyStorefrontCustomerQuery> {
  return shopifyStorefrontRequest({
    storeCode,
    document,
    variables: {
      customerAccessToken
    }
  });
}
